// Who may be CHOSEN in a dropdown, versus who a record already holds.
//
// The rule (Karen Sweatman + Robert, 2026-08-12): a retired account or a retired
// lookup row must not be OFFERED, but the one a record is already on must never
// disappear from its own dropdown. Users default to clicking Save rather than
// Cancel, so a value missing from the list is a value silently cleared off the
// job the moment somebody opens an old one and saves it. "Resource Department"
// held 6,076 jobs only because 1.0 auto-assigned every new job to it; drop it
// from the list and those 6,076 open with a blank Project Co-Ordinator.
//
// This is only about ASSIGNMENT surfaces. Search and report FILTERS take the
// opposite rule and drop inactive rows outright — see `activeOnly` in
// services/apiClient.js — because filtering by somebody and assigning work to
// them are different questions.
//
// Deliberately `!== false` rather than truthy: rows from endpoints that don't
// select is_active have it undefined, and an unknown flag must not retire a row.

export const isRetired = (row) => row?.is_active === false;

/** Active rows, plus whichever row `currentId` points at even if it is retired. */
export function selectableRows(rows, currentId) {
  const current = currentId === null || currentId === undefined ? "" : String(currentId);
  return (rows || []).filter((row) => !isRetired(row) || String(row.id) === current);
}

/** Dropdown label with the retirement marked, so a kept-for-history row reads as one. */
export function rowLabel(row, labelKey = "full_name") {
  return `${row?.[labelKey] ?? ""}${isRetired(row) ? " (inactive)" : ""}`;
}
